import classNames from 'classnames';
import React, { useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import useStyles from './useStyles';
let defer = () => { };
export const toast = (...args) => {
    defer(...args);
};
export const ToastContainer = ({ children, className = '' }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [list, setList] = useState([]);
    const [extra, setExtra] = useState(undefined);
    const [type, setType] = useState('success');
    defer = (type_, message_, list_, extra_) => {
        setType(type_);
        setMessage(message_);
        setList(list_);
        setExtra(extra_);
        setOpen(false);
        setTimeout(() => {
            setOpen(true);
        });
    };
    const handleClose = () => {
        setOpen(false);
    };
    const styles = useStyles();
    const classes = classNames(styles.root, styles[`root__${type}`], className);
    return (React.createElement("div", null,
        children,
        React.createElement(Snackbar, { open: open, autoHideDuration: 10000, onClose: handleClose, anchorOrigin: { vertical: 'top', horizontal: 'center' } },
            React.createElement(Alert, { onClose: handleClose, severity: type, variant: "filled", className: classes },
                React.createElement("div", null, message),
                list && (React.createElement("ul", null, list.map((item, i) => (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement("li", { key: i }, item))))),
                extra && React.createElement("div", { style: { marginTop: '1em' } }, extra)))));
};
